import React from "react";
import { string } from "prop-types";
import * as style from "./styles.module.scss";

const SpacedOutText = ({ children }) => {
  return <p className={style.spacedout}>{children}</p>;
};

SpacedOutText.propTypes = {
  children: string,
};

export default SpacedOutText;
